import { AnyAction } from 'redux';
import { BaseTransientState, Rolle } from '@ps20-frontend/frontend-models';
import {
  GlobalActions,
  GlobalFeatureToggleReceivedAction,
  GlobalRegexReceivedAction,
  GlobalRoleDeterminedAction,
} from '@ps20-frontend/shop-integration-redux';
import { GegeActions } from '../gegeActions';

export interface TransientState extends BaseTransientState, Rolle {}

export const transientStateReducer = function (
  sectionState: TransientState = null,
  action: AnyAction,
): TransientState {
  switch (action.type) {
    case GegeActions.ZURUECK_ZUM_SHOP_MODAL_OPEN:
      return { ...sectionState, zurueckZumShopModalOpen: true };
    case GegeActions.ZURUECK_ZUM_SHOP_MODAL_CLOSE:
      return { ...sectionState, zurueckZumShopModalOpen: false };
    case GlobalActions.ROLE_DETERMINED:
      return { ...sectionState, role: (action as GlobalRoleDeterminedAction).payload.role };
    case GlobalActions.FEATURE_TOGGLE_RECEIVED:
      return {
        ...sectionState,
        featureToggles: (action as GlobalFeatureToggleReceivedAction).payload,
      };
    case GlobalActions.REGEXPS_RECEIVED:
      return { ...sectionState, regexps: (action as GlobalRegexReceivedAction).payload };
    case GlobalActions.SETTINGS_RECEIVED:
      return {
        ...sectionState,
        settings: action.payload,
      };
    case GlobalActions.KOOPERATIONEN_LIST_RECEIVED: {
      return {
        ...sectionState,
        kooperationen: action.payload,
      };
    }
    case GlobalActions.SET_PRICE_GUARANTEE:
      return { ...sectionState, priceGuarantee: action.payload };
    case GlobalActions.CHANGE_RELEVANT_RISKDATA_HASH:
      return { ...sectionState, priceGuarantee: false };
    default:
      return sectionState;
  }
};
